import React from 'react';
import { FadeIn, Section } from './Shared';
import { X, AlertTriangle } from 'lucide-react';
export const ProblemSection = () => {
  const myths = ['“Debes comer menos”', '“Debes hacer más ejercicio”', '“Es normal con la edad”'];
  const consequences = [{
    text: 'No produce energía',
    result: 'te sientes agotada'
  }, {
    text: 'Acumula grasa',
    result: 'aparece el abdomen inflamado'
  }, {
    text: 'Genera inflamación',
    result: 'te ves hinchada constantemente'
  }];
  return <Section bg="cream" data-id="element-259">
      <FadeIn data-id="element-260">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-261">
          Durante años te hicieron creer que:
        </h2>
      </FadeIn>

      <div className="max-w-xl mx-auto space-y-3 mb-8" data-id="element-262">
        {myths.map((myth, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-263">
            <div className="flex items-center gap-3 text-gray-600" data-id="element-264">
              <X className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-265" />
              <p className="text-lg italic" data-id="element-266">{myth}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.3} data-id="element-267">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8 text-center" data-id="element-268">
          <h3 className="text-2xl font-bold mb-4" data-id="element-269">Pero nadie te dijo esto:</h3>
          <p className="text-xl text-brand-teal font-medium" data-id="element-270">
            Tu cuerpo no está fallando. Tu filtro interno está saturado.
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-271">
        <h3 className="text-2xl font-bold text-center mb-6" data-id="element-272">
          Cuando tu hígado está sobrecargado:
        </h3>
      </FadeIn>

      <div className="grid gap-3 max-w-2xl mx-auto mb-8" data-id="element-273">
        {consequences.map((item, index) => <FadeIn key={index} delay={0.5 + index * 0.1} data-id="element-274">
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-275">
              <div className="flex items-center gap-2 text-brand-charcoal font-semibold" data-id="element-276">
                <AlertTriangle className="w-5 h-5 text-brand-yellow" data-id="element-277" />
                <span data-id="element-278">{item.text}</span>
              </div>
              <span className="hidden sm:block text-gray-300" data-id="element-279">→</span>
              <span className="text-gray-600 sm:ml-auto" data-id="element-280">{item.result}</span>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.8} data-id="element-281">
        <p className="text-center text-2xl font-bold text-gray-800" data-id="element-282">
          Y entonces… <span className="text-brand-teal" data-id="element-283">nada funciona.</span>
        </p>
      </FadeIn>
    </Section>;
};